import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum WidgetShapeErrorCode {
  UndefinedCompRef = 'UndefinedCompRef',
  NotAvailableMethod = 'NotAvailableMethod',
}

class WidgetShapeError extends BaseError<WidgetShapeErrorCode> {
  constructor(message: string, code: WidgetShapeErrorCode) {
    super(message, code, 'Widget Error');
  }
}

export const createWidgetShapeError = createErrorBuilder<
  WidgetShapeErrorCode,
  WidgetShapeError
>(WidgetShapeError);
